<template>
  <div class="dingdan">
    <Breadtabsheader/>
    <div class="h-piece h-mrt30 margin">
      <div class="h-formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="货物名称" prop="goodsName" style="width: 50%;">
              <el-input v-model="formInline.goodsName" placeholder="请输入货物名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号" prop="sapCode" style="width: 50%;">
              <el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用逗号隔开" clearable></el-input>
            </el-form-item>
            <el-form-item label="合同编码" prop="contractNo" style="width: 50%;">
              <el-input v-model="formInline.contractNo" placeholder="多合同模糊查询请用逗号隔开" clearable></el-input>
            </el-form-item>
            <el-form-item label="公司名称或编码" prop="soldToName" style="width: 50%;">
              <el-input v-model="formInline.soldToName" placeholder="请输入公司名称或编码" clearable></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-table h-mrt30">
      <el-table ref="ddtable" :data="tableData" border :show-overflow-tooltip="true"
          style="width: 100%">
        <el-table-column
            type="index"
            fixed
            label="#"
            width="40">
        </el-table-column>
        <el-table-column
            prop="sapCode"
            label="订单号"
            fixed
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="contractNo"
            label="合同编码"
            fixed
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="soldToCode"
            label="客户代号"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="soldToName"
            label="公司名称"
            :show-overflow-tooltip="true"
            width="150">
        </el-table-column>
        <el-table-column
            prop="sendAddress"
            label="发货地址"
            :show-overflow-tooltip="true"
            width="150">
        </el-table-column>
        <el-table-column
            prop="goodsName"
            label="货物名称"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="customerModel"
            label="客户型号"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="corresponModel"
            label="对应型号"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="proNumber"
            label="订单数量"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="finalPrice"
            label="单价"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="totalPrice"
            label="总价"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="sendWay"
            label="发货方式"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="note"
            label="备注"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="businessAttributionName"
            label="业务归属"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="cdate"
            label="发货日期"
            :show-overflow-tooltip="true"
            :formatter="formatDatecc"
            width="110">
        </el-table-column>
<!--        <el-table-column
            fixed="right"
            label="操作"
            width="150">
          <template slot-scope="scope">
            <div style="text-align: left;">
              <di style="text-align: left;">
                <el-button
                    size="small" class="h-tableLink h-btn"
                    @click="updateDetail(scope.row)">编辑
                </el-button>
              </di>
            </div>
          </template>
        </el-table-column>-->
      </el-table>
    </div>
    <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
      <pagination :page="formInline" @query="query"/>
      <div style="display:flex;align-items: center;margin-left: 20px">
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                   @click="exportExcel()">批量导出
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import ss from "@/api/SystemService";
  import updownfile from "@/utils/updownfile";

  export default {
    data() {
      return {
        //表单
        formInline: {
          pageSize: 10,
          pageNo: 1,
          total: 0,
          sapCode:null,
          contractNo:null,
          soldToName:null,
          goodsName:null,
        },
        tableData: [],
      }
    },
    created() {
      this.query();
    },
    methods: {
      //重置
      resetData(){
        this.formInline.sapCode = null;
        this.formInline.contractNo = null;
        this.formInline.soldToName = null;
        this.formInline.goodsName = null;
      },
      //查询
      query() {
        ss.OrderMainService.selectRecordPage(this.formInline).then(rd => {
          this.tableData = rd.records;
          this.formInline.total = rd.total || 0;
        });
      },
      //导出
      exportExcel(){
        updownfile.down("/api/swyl/v1/sendGoodsRecord/exportRecord",this.formInline,"post",'sata');
        /*ss.OrderMainService.exportRecord(this.formInline).then(res => {
          // 处理返回的文件流
          const link = document.createElement('a')
          let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', `元析发货计划详情.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }).catch(function (error) {
          console.log("导出错误",error.toString())
        });*/
      },
      /**
       * 凭证过账日期格式化
       * @param row
       * @param column
       * @returns {string|null}
       */
      formatDatecc(row, column) {
        // 获取单元格数据
        let data = row[column.property]
        if(data == null || data == '') {
          return null
        }
        let dt = new Date(data)
        return this.$util.riQi3(dt);
      },
    }
  }
</script>

<style scoped>
.xiangmu .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 1rem !important;
}

.D-date .el-cascader {
  line-height: 0;
}
</style>